import React, { useState, useEffect } from "react";
import axios from "axios";
import "./ExportarDados.css";

const ExportarDados = () => {
  const hoje = new Date();
  hoje.setMinutes(hoje.getMinutes() - hoje.getTimezoneOffset());
  const yyyyMmDdHoje = hoje.toISOString().split("T")[0];

  const [tipo, setTipo] = useState("");
  const [dataInicio, setDataInicio] = useState(`${new Date().getFullYear()}-01-01`);
  const [dataFim, setDataFim] = useState(yyyyMmDdHoje);
  const [formato, setFormato] = useState("");
  const [statusAcao, setStatusAcao] = useState("");
  const [objecoes, setObjecoes] = useState([]);
  const [objecaoSelecionada, setObjecaoSelecionada] = useState("todas");
  const [estagioSelecionado, setEstagioSelecionado] = useState("todos");
  const [tags, setTags] = useState([]);
  const [tagsSelecionadas, setTagsSelecionadas] = useState([]);
  const [tagsAnd, setTagsAnd] = useState(false);
  const [usuarios, setUsuarios] = useState([]);
  const [usuarioSelecionado, setUsuarioSelecionado] = useState("");
  const [tipoUsuario, setTipoUsuario] = useState("");

  const estagiosFunil = [
    "Contato Inicial",
    "Qualificação",
    "Acompanhamento",
    "Agendamento",
    "Agendado",
    "Cliente",
  ];

  // Descobrir tipo de usuário + (se master) listar usuários
  useEffect(() => {
    axios
      .get("https://welaunchyou.com.br/crm-wly/getUser.php", { withCredentials: true })
      .then((res) => {
        if (res.data?.tipo_usuario) {
          setTipoUsuario(res.data.tipo_usuario);
          if (res.data.tipo_usuario === "master") {
            axios
              .get("https://welaunchyou.com.br/crm-wly/listagem_usuarios.php", { withCredentials: true })
              .then((r) => {
                if (r.data?.usuarios) setUsuarios(r.data.usuarios);
              })
              .catch((err) => console.error("Erro ao buscar usuários:", err));
          }
        }
      })
      .catch((err) => console.error("Erro ao buscar tipo de usuário:", err));
  }, []);

  // Carregar TAGS (respeita master/usuarioSelecionado)
  const carregarTags = () => {
    let url = "https://welaunchyou.com.br/crm-wly/tags.php";
    if (tipoUsuario === "master" && usuarioSelecionado) {
      url += `?usuario_id=${usuarioSelecionado}`;
    }
    axios
      .get(url, { withCredentials: true })
      .then((response) => {
        const d = response.data;
        const lista =
          Array.isArray(d) ? d :
          Array.isArray(d?.tags) ? d.tags :
          Array.isArray(d?.resumo) ? d.resumo : [];
        setTags(lista.map((t) => ({ id: Number(t.id), nome: t.nome })));
      })
      .catch((error) => console.error("Erro ao buscar tags:", error));
  };

  useEffect(() => {
    // carrega tags sempre (mesmo se não for "leads", fica em cache)
    carregarTags();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [usuarioSelecionado, tipoUsuario]);

  // Carregar Objeções quando tipo = objecoes (respeita master/usuarioSelecionado)
  useEffect(() => {
    if (tipo !== "objecoes") return;
    let url = "https://welaunchyou.com.br/crm-wly/listagem_objecoes.php";
    if (tipoUsuario === "master" && usuarioSelecionado) {
      url += `?usuario_id=${usuarioSelecionado}`;
    }
    axios
      .get(url, { withCredentials: true })
      .then((response) => {
        if (Array.isArray(response.data?.objecoes)) {
          setObjecoes(response.data.objecoes);
        } else {
          setObjecoes([]);
        }
      })
      .catch((error) => console.error("Erro ao buscar objeções:", error));
  }, [tipo, tipoUsuario, usuarioSelecionado]);

  // Ao mudar o "tipo", limpar seleções que não se aplicam
  useEffect(() => {
    if (tipo !== "leads") {
      setTagsSelecionadas([]);
      setTagsAnd(false);
      setEstagioSelecionado("todos");
    }
    if (tipo !== "objecoes") {
      setObjecaoSelecionada("todas");
    }
    if (tipo !== "acoes") {
      setStatusAcao("");
    }
  }, [tipo]);

  const handleTagChange = (tagId) => {
    setTagsSelecionadas((prev) =>
      prev.includes(tagId) ? prev.filter((id) => id !== tagId) : [...prev, tagId]
    );
  };

  const handleExportar = (e) => {
    e.preventDefault();

    if (!tipo || !formato) {
      alert("Por favor, selecione o tipo de dados e o formato.");
      return;
    }

    const params = new URLSearchParams({
      tipo,
      data_inicio: dataInicio || "",
      data_fim: dataFim || "",
      formato,
    });

    if (tipoUsuario === "master" && usuarioSelecionado) {
      params.append("usuario_id", usuarioSelecionado);
    }

    if (tipo === "acoes") {
      // backend espera: pendente | concluida | todas
      params.append("status_acao", statusAcao || "todas");
    }

    if (tipo === "objecoes") {
      params.append("objecao", objecaoSelecionada || "todas");
    }

    if (tipo === "leads") {
      params.append("estagio_funil", estagioSelecionado || "todos");
      if (tagsSelecionadas.length > 0) {
        params.append("tags", tagsSelecionadas.join(","));
        params.append("tags_and", tagsAnd ? "1" : "0");
      }
    }

    window.open(
      `https://welaunchyou.com.br/crm-wly/exportar_dados.php?${params.toString()}`,
      "_blank"
    );
  };

  return (
    <div className="exportar-custom">
      <h1>Exportação de Dados</h1>

      <div className="container-exportar-custom">
        <form onSubmit={handleExportar} className="export-form-custom">
          <div className="form-group-custom">

            <div className="form-group-custom">
              <label htmlFor="tipo">Tipo de Dados:</label>
              <select id="tipo" value={tipo} onChange={(e) => setTipo(e.target.value)} required>
                <option value="">Selecione</option>
                <option value="leads">Leads</option>
                <option value="acoes">Ações</option>
              </select>
            </div>

            {tipoUsuario === "master" && (
              <div className="form-group-custom">
                <label htmlFor="usuario_id">Usuário:</label>
                <select
                  id="usuario_id"
                  value={usuarioSelecionado}
                  onChange={(e) => setUsuarioSelecionado(e.target.value)}
                >
                  <option value="">Todos</option>
                  {usuarios.map((user) => (
                    <option key={user.id} value={user.id}>
                      {user.nome_empresa || user.nome || `Usuário ${user.id}`}
                    </option>
                  ))}
                </select>
              </div>
            )}
          </div>

          {tipo === "leads" && (
            <div className="form-group-custom">
              <label htmlFor="estagio_funil">Estágio do Funil:</label>
              <select
                id="estagio_funil"
                value={estagioSelecionado}
                onChange={(e) => setEstagioSelecionado(e.target.value)}
              >
                <option value="todos">Todos</option>
                {estagiosFunil.map((estagio) => (
                  <option key={estagio} value={estagio}>
                    {estagio}
                  </option>
                ))}
              </select>
            </div>
          )}

          {tipo === "acoes" && (
            <div className="form-group-custom">
              <label htmlFor="status_acao">Status da Ação:</label>
              <select
                id="status_acao"
                value={statusAcao}
                onChange={(e) => setStatusAcao(e.target.value)}
              >
                <option value="todas">Todas</option>
                <option value="pendente">Pendentes</option>
                <option value="concluida">Concluídas</option>
              </select>
            </div>
          )}

          {tipo === "objecoes" && (
            <div className="form-group-custom">
              <label htmlFor="objecao">Objeção:</label>
              <select
                id="objecao"
                value={objecaoSelecionada}
                onChange={(e) => setObjecaoSelecionada(e.target.value)}
              >
                <option value="todas">Todas</option>
                {objecoes.map((obj) => (
                  <option key={obj.id ?? obj.descricao} value={obj.descricao}>
                    {obj.descricao}
                  </option>
                ))}
              </select>
            </div>
          )}

          <div className="datas-inline-container">
            <div className="form-group-inline">
              <label htmlFor="data_inicio">Data Início:</label>
              <input
                type="date"
                id="data_inicio"
                value={dataInicio}
                onChange={(e) => setDataInicio(e.target.value)}
              />
            </div>

            <div className="form-group-inline">
              <label htmlFor="data_fim">Data Fim:</label>
              <input
                type="date"
                id="data_fim"
                value={dataFim}
                onChange={(e) => setDataFim(e.target.value)}
              />
            </div>
          </div>

          <div className="form-group-custom">
            <label htmlFor="formato">Formato:</label>
            <select id="formato" value={formato} onChange={(e) => setFormato(e.target.value)} required>
              <option value="">Selecione</option>
              <option value="csv">CSV</option>
              <option value="excel">Excel</option>
              <option value="pdf">PDF</option>
            </select>
          </div>

          {tipo === "leads" && tags.length > 0 && (
            <div className="form-group-custom">
              <label>Filtrar por Tags:</label>

              <div className="select-all-container">
                <label className="select-all-checkbox">
                  <input
                    type="checkbox"
                    onChange={(e) =>
                      setTagsSelecionadas(e.target.checked ? tags.map((t) => t.id) : [])
                    }
                    checked={tagsSelecionadas.length === tags.length && tags.length > 0}
                  />
                  Marcar todas
                </label>

                <label className="select-all-checkbox">
                  <input
                    type="checkbox"
                    onChange={() => setTagsSelecionadas([])}
                    checked={tagsSelecionadas.length === 0}
                  />
                  Desmarcar todas
                </label>
              </div>

              <div className="tags-grid-custom">
                {tags.map((tag) => (
                  <label key={tag.id} className="tag-checkbox-custom">
                    <input
                      type="checkbox"
                      value={tag.id}
                      checked={tagsSelecionadas.includes(tag.id)}
                      onChange={() => handleTagChange(tag.id)}
                    />
                    <span>{tag.nome}</span>
                  </label>
                ))}
              </div>

              <div className="toggle-container-custom">
                <span className={!tagsAnd ? "active" : ""}>Alguma das</span>
                <label className="switch-toggle-custom">
                  <input
                    type="checkbox"
                    checked={tagsAnd}
                    onChange={() => setTagsAnd((v) => !v)}
                  />
                  <span className="slider-toggle-custom round"></span>
                </label>
                <span className={tagsAnd ? "active" : ""}>Todas as</span>
              </div>
            </div>
          )}

          <button type="submit" className="export-btn-custom">Exportar</button>
        </form>
      </div>
    </div>
  );
};

export default ExportarDados;
